import script from "./GameImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameImage.vue?vue&type=script&setup=true&lang=ts"

import "./GameImage.vue?vue&type=style&index=0&id=13399612&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13399612"]])

export default __exports__